const userUrls = {
  profile: "/profile",
  settings: "/settings",
  logiout: "/logout",
};

export default userUrls;
